var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[(_vm.isLoadingScreen)?_c('LoadingScreen'):_c('ReportComponent',{attrs:{"dataSource":_vm.dataSource,"cashier":_vm.cashier,"dateTo":_vm.dateTo,"dateFrom":_vm.dateFrom,"dataReport":_vm.dataReport,"isFinal":this.$route.meta.isFinal,"valueDate":_vm.valueDate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }